import { render, staticRenderFns } from "./InstitutionList.vue?vue&type=template&id=11994aad"
import script from "./InstitutionList.vue?vue&type=script&lang=js"
export * from "./InstitutionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports